module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/Programing/carbooking/src/app/shared/components/layouts/auth-layout/auth-layout.component.html
// module id = ../../../../../src/app/shared/components/layouts/auth-layout/auth-layout.component.html
// module chunks = main